//address type
export const pick_up = "1";
export const drop_off = "2";

//Customer Requests tab constants

export const active = "0";
export const completed = "1";
export const cancelled = "2";

export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const SORT_BY_OPTIONS = [
  { label: "Request ID", value: "id" },
  { label: "Movers", value: "movers" },
  { label: "Schedule Time", value: "schedule_time" },
  { label: "Move Type", value: "move_type" },
  { label: "Net Distance", value: "net_distance" },
  { label: "Request Timeline Status", value: "request_timeline_status" },
];

export const TIMELINE_STATUS_OPTIONS = [
  { label: "New Request", value: "0" },
  // { label: "Bid submitted", value: "1" },
  // { label: "Bid accepted", value: "2" },
  { label: "Awaiting Customer Response / Direct Request Accepted", value: "3" },
  { label: "Truck assigned and ready to move", value: "4" },
  { label: "Move in progress", value: "5" },
  { label: "Completed, waiting for confirmation", value: "6" },
  { label: "Completed", value: "7" },
  { label: "Feedback Given", value: "8" },
];
